import { Grid, Stack, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import DeleteButton from 'components/session_info/button/delete';
import useMobile from 'hooks/use_mobile';
import { IndexListItem } from 'components/styles_components/list';
import FormattedDate from 'components/date';

const current = (sessionInfo) => {
  if (sessionInfo.current) {
    return (
      <>
        {' '}
        <Typography color="primary" component="span">
          (<FormattedMessage id="session_info.current" />)
        </Typography>
      </>
    );
  }
  return null;
};

const device = (sessionInfo) => {
  return [sessionInfo.platform, sessionInfo.os].filter(Boolean).join(' · ');
};

const browser = (sessionInfo) => {
  return [sessionInfo.browserName, sessionInfo.browserVersion].filter(Boolean).join(' ');
};

const ListItem = ({ sessionInfo, onRemove }) => {
  const isMobile = useMobile();

  return (
    <IndexListItem>
      <Grid container spacing={2}>
        {isMobile ? (
          <>
            <Grid size={{ xs: 8 }} textAlign="left">
              <Stack>
                <Typography>{device(sessionInfo)}</Typography>
                <Typography>{browser(sessionInfo)}</Typography>
                <Typography>{sessionInfo.ip}</Typography>
                <Typography>
                  <FormattedDate date={sessionInfo.createdAt} />
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 4 }} textAlign="right">
              <DeleteButton sessionInfo={sessionInfo} onRemove={onRemove} />
            </Grid>
          </>
        ) : (
          <>
            <Grid size={{ xs: 3 }} textAlign="left">
              {device(sessionInfo)}
              {current(sessionInfo)}
            </Grid>
            <Grid size={{ xs: 3 }} textAlign="center">
              {browser(sessionInfo)}
            </Grid>
            <Grid size={{ xs: 2 }} textAlign="center">
              {sessionInfo.ip}
            </Grid>
            <Grid size={{ xs: 2 }} textAlign="center">
              <FormattedDate date={sessionInfo.createdAt} />
            </Grid>
            <Grid size={{ xs: 2 }} textAlign="center">
              <DeleteButton sessionInfo={sessionInfo} onRemove={onRemove} />
            </Grid>
          </>
        )}
      </Grid>
    </IndexListItem>
  );
};

export default ListItem;
